import type { ReactElement } from "react";
import { useRef } from "react";
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";
import type { PaperProps } from "@mui/material";

export default function DraggablePaper(props: PaperProps): ReactElement {
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <Draggable
      handle=".custom-dialog-header"
      cancel={'[class*="MuiDialogContent-root"]'}
      nodeRef={nodeRef}
      bounds="parent"
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
